import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (
  theme,
  mainColor,
  secondaryColor,
  iconColor,
  height,
  width
) => ({
  icon: {
    p: "5px",
    height: {
      xs: "10px",
      sm: "11.25px",
      md: "12.5px",
      lg: "13.75",
      xl: "15px",
    },
    width: { xs: "10px", sm: "11.25px", md: "12.5px", lg: "13.75", xl: "15px" },
    borderRadius: "58px",
    bgcolor: theme.palette.white.secondary,
    color: iconColor,
    ml: { xs: "3px", sm: "6px", md: "9px", lg: "12px", xl: "15px" },
  },
  button: {
    borderRadius: "100px",
    color: theme.palette.white.secondary,
    background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    fontSize: {
      xs: "14px",
      sm: "14.5px",
      md: "15px",
      lg: "15.5px",
      xl: "16px",
    },
    lineHeight: {
      xs: "25.2px",
      sm: "27",
      md: "28.8",
      lg: "30.6",
      xl: "32.4px",
    },
    height,
    width: {
      xs: "170px",
      sm: "179.5px",
      md: "203px",
      lg: "226.5",
      xl: width ? width : "245px",
    },
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.secondary,
      background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    },
    letterSpacing: { xs: "0.28px", md: "0.36px" },
  },
});

const WantToApplyButton = ({
  mb,
  mt,
  mainColor,
  secondaryColor,
  iconColor,
  navigateTo,
  height,
  width,
  data,
  text
}) => {
  const theme = useTheme();
  const classes = useStyles(
    theme,
    mainColor,
    secondaryColor,
    iconColor,
    height,
    width
  );
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "WantToApplyButton");

  const goTo = () => {
    navigate(navigateTo);
    window.scrollTo(0, 0);
  };

  const handleData = () => {
    if (data && data.priceARS && data.priceUSD)
      localStorage.setItem("data", JSON.stringify(data));
  };

  return (
    <Button
      onClick={() => {
        goTo();
        handleData();
      }}
      endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
      variant="contained"
      sx={{ ...classes.button, mb, mt }}
    >
      {text ? text : title}
    </Button>
  );
};

export default WantToApplyButton;
